import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["patientId"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createCrud, useAxiosClient, useQuery } from '@lumahealthhq/ui-model';
var crud = createCrud('signatures');
var BASE_URL = 'v2/signatures';
export var usePatientSignatureCreateOne = crud.makeCreateOne();
export function useSignatureByPatient(params, options) {
  var axiosClient = useAxiosClient();
  var patientId = params.patientId,
    otherParams = _objectWithoutProperties(params, _excluded);
  var URL = "".concat(BASE_URL, "/patient/").concat(patientId);
  var fetchFn = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$axiosClient$ge, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axiosClient.get(URL, {
              params: otherParams
            });
          case 2:
            _yield$axiosClient$ge = _context.sent;
            data = _yield$axiosClient$ge.data;
            return _context.abrupt("return", data);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function fetchFn() {
      return _ref.apply(this, arguments);
    };
  }();
  return useQuery([BASE_URL, otherParams], fetchFn, options);
}